import { useQuery } from 'react-query'

import { CommentFilterType } from '@client/collections/Comment/inteface'
import { CommentsResponse } from '@models/comment/CommentsResponse'
import { useCommentAction } from './useCommentAction'

export const useComments = (
  params: CommentFilterType,
  {
    enabled,
    onSuccess,
  }: { enabled?: boolean; onSuccess?: (data: CommentsResponse) => void }
) => {
  const commentClient = useCommentAction()

  const { data, isLoading, refetch } = useQuery(
    ['comments', params],
    () => commentClient.comments(params),
    { enabled, onSuccess }
  )
  return { data, isLoading, refetch }
}
